import * as React from 'react'
import Persistence from '../Components/Persistence'

import * as _ from 'lodash'

import StudentDash from '../Components/Dashboard/StudentDash'
import ScheduleDay from '../Components/Schedule/ScheduleDay'
import ExpenseRow from '../Components/Expenses/ExpenseRow'
import NotesRow from '../Components/Notes/NotesRow'

import Main from '../Components/Main'

import { T } from '@homeschooling/sdk'

import SDKFactory from '../Components/SDKFactory'

Persistence.setValues()

interface Props { }

interface State {
    isLoading: boolean,
    students: T.StudentDash[],
    schedule: T.ScheduleDay[],
    expenses: T.Expense[],
    notes: T.Progress[]
}

export class Dashboard extends React.Component<Props, State> {
    private sdk = SDKFactory.getUsersSDK()

    public constructor (props: Props) {
        super(props)
    
        this.state = {
          isLoading: true,
          students: [],
          expenses: [],
          schedule: [],
          notes: []
        }
      }

    public async componentDidMount() {
        
        try {
            const res = await this.sdk
              .getUserDash()
  
              let dash = res.data
              const hasError: boolean = _.get(res, 'error', false) as boolean
              if(!hasError){
                this.setState({
                    students: dash.students,
                    schedule: dash.upcomingSchedule,
                    expenses: dash.recentExpenses,
                    notes: dash.recentNotes,
                    isLoading: false
                })
              } else {
                console.log('Errored', res)
                Persistence.clear()
              }
          } catch (reason) {
            console.log('Error getting user dash', reason)
          }  
    }

    public getStudentsDash = () => {
        let students:any[] = []

        for(let s of this.state.students){
            students.push(<StudentDash student={s}/>)
        }
        
        return students
    }

    public getSchedulde = () => {
        let schedule: T.ScheduleDay[] = this.state.schedule

        let display = []

        for(let s of schedule){
            display.push(<ScheduleDay schedule={s} 
            updateSchedule={() => console.log('update later')}    
            updateExpense={() => console.log('update later')}
            updateNote={() => console.log('update later')}  />)
        }
        

        return (
        <div className='w-full grid gap-1 grid-cols-7'>
            {display}
        </div>
        )
    }

    public getExpenses = () => {
        let expenses = this.state.expenses
        let display = []

        for(let e of expenses){
            display.push(<ExpenseRow expense={e} position={expenses.indexOf(e)}> </ExpenseRow>)
        }
        
        return (
            <div className='w-full h-auto'>
                <div id={`expense_header`} className="flex items-center flex-row justify-left h-auto py-3 font-semibold bg-slate-100">
                    <div className='w-12 flex flex-row items-center text-left text-xs flex-none'>
    
                    </div>  
                    <div className='w-12 grow text-left flex-none align-middle text-s px-2'>
                        Description
                    </div>
                    <div className='w-44 text-left text-sm flex-none align-middle'>
                        Paid to
                    </div>
                    <div className='w-36 text-left text-sm align-middle flex-none'>
                        Industry
                    </div>
                    <div className='w-24 h-auto text-sm align-middle text-center px-2 flex-none'>
                        Price 
                    </div>
                    <div className='w-28 text-center text-sm align-middle flex-none'>
                        Date
                    </div>
                </div>
                <div className=' border-y-0.5 divide-y-0.5 border-slate-600 divide-slate-600'>
                    {display}
                </div>
            </div>
            )
    }

    public getNotes = () => {
        let notes = this.state.notes
        let display = []

        for(let n of notes){
            display.push(<NotesRow note={n} position={notes.indexOf(n)}> </NotesRow>)
        }
        
        return (
            <div className='w-full min-height-4'>
                  <div id={`notes_header`} className="flex items-center flex-row justify-left h-auto py-3 font-semibold bg-slate-100">
                    <div className='w-12 flex flex-row items-center text-left text-xs flex-none'>
        
                    </div>  
                    <div className='w-12 grow text-left flex-none align-middle text-gray-600 text-s px-2'>
                    Description
                    </div>
                    <div className='w-36 text-left text-sm align-middle flex-none'>
                    Subject
                    </div>
                    <div className='w-36 text-sm align-middle text-left px-2 flex-none'>
                    Course
                    </div>
                    <div className='w-28 text-center text-sm align-middle flex-none'>
                    Date
                    </div>
                </div>
                <div className=' border-y-0.5 divide-y-0.5 border-slate-600 divide-slate-600'>
                    {display}
                </div>
            </div>
            )
    }


    public render () {

        return (
            <Main>
                <div className='m-10'>
                    <div className="flex w-full justify-center">

                        {this.getStudentsDash()}

                    </div>

                    <div className='w-full justify-center mb-16'>
                        <h3 className="text-left w-full text-l text-gray-600 font-medium leading-8">Upcoming Schedule</h3>
                            {this.getSchedulde()}    
                    </div>

                    <div className='w-full justify-center mb-16'>
                        <h3 className="text-left w-full text-l text-gray-600 font-medium leading-8">Recent Progree</h3>
                        <div className='flex w-full justify-left min-h-4'>
                            {this.getExpenses()}
                        </div>
                    </div>

                    <div className='w-full justify-center'>
                        <h3 className="text-left w-full text-l text-gray-600 font-medium leading-8">Recent Expenses</h3>
                        <div className='flex w-full justify-left min-height-4'>
                            {this.getNotes()}
                        </div>
                    </div>
                </div>
                
            </Main>
        )
    }
}

export default Dashboard